module.exports = __webpack_public_path__ + "static/media/abtt.689155de.webp";